var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.getAvatar || !_vm.SASKey)?_c('v-avatar',{staticClass:"text-subtitle-1 justify-center",attrs:{"size":"40","color":_vm.avatarBackgroundColor}},[_vm._v(" "+_vm._s(_vm.initials)+" ")]):_c('v-avatar',{staticClass:"text-subtitle-1 justify-center",attrs:{"size":"40"}},[_c('v-img',{attrs:{"src":_vm.getAvatar + '&' + this.SASKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }